module.exports = __webpack_public_path__ + "static/BT-mobile-10-4ead50b22228f1edbb38a442314c5e19.jpg";